import React from 'react';
import { TextFieldEditor } from '../../components';
import s from './HostStyles.module.scss';

const TextFieldEditorHost = () => (
    <div style={{ padding: '100px' }}>
        <div className={s.editor}>
            <TextFieldEditor label="labeloo" value="Tomato Paste" iconLeft="icon-movierental" />
        </div>
        <div style={{ marginTop: '50px' }} className={s.editor}>
            <TextFieldEditor label="banana fudge" value="Cheetos" />
        </div>
        <div style={{ marginTop: '50px' }} className={s.editor}>
            <TextFieldEditor label="disabled" value="Cheetos" disabled />
        </div>
        <div style={{ marginTop: '50px' }} className={s.editor}>
            <TextFieldEditor big label="Big" value="Cheetos" iconLeft="icon-movierental" />
        </div>
        <div style={{ marginTop: '50px' }} className={s.editor}>
            <TextFieldEditor />
        </div>
    </div>
);

export default TextFieldEditorHost;
